<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <!-- <el-tab-pane label="评价记录" name="first">
                <child1></child1>
            </el-tab-pane> -->
            
            <el-tab-pane label="我的评价" name="four">
                <child4 v-if="activeName == 'four'"></child4>
            </el-tab-pane>

            <el-tab-pane label="学生评价统计" name="second">
                <child2 v-if="activeName == 'second'"></child2>    
            </el-tab-pane>

            <el-tab-pane label="班级评价统计" name="three">
                <child3 v-if="activeName == 'three'"></child3>    
            </el-tab-pane>

            <el-tab-pane label="班级评价AI周报" name="eight">
                <child8 v-if="activeName == 'eight'"></child8>
            </el-tab-pane>

            <el-tab-pane label="教职评价统计" name="five">
                <child5 v-if="activeName == 'five'"></child5>    
            </el-tab-pane>

            <el-tab-pane label="校长报告" name="six">
                <child6 v-if="activeName == 'six'"></child6>    
            </el-tab-pane>

            <el-tab-pane label="巡岗留痕" name="seven">
                <child7 v-if="activeName == 'seven'"></child7>    
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    // import evaluate from './Evaluate'
    import myEvaluate from './MyEvaluate'
    import studentEvaluateCount from './StudentEvaluateCount'
    import classEvaluateCount from './ClassEvaluateCount'
    import teacherEvaluateCount from './TeacherEvaluateCount'
    import headMaster from './headMaster/list'
    import classWeekReport from './classWeekReport/list'
    import patrolRecord from './patrol/list'

    export default {
        name:"EvaluateMain",
        components:{
            // child1:evaluate,
            child4:myEvaluate,
            child2:studentEvaluateCount,
            child3:classEvaluateCount,
            child5:teacherEvaluateCount,
            child6:headMaster,
            child8:classWeekReport,
            child7:patrolRecord
        },
        data() {
            return {
                menuName:"",
                activeName: "four",
                title:"我的评价"
            }
        },
        created:function () {
            console.log('patrolRecord:', patrolRecord)

            this.menuName = sessionStorage.getItem("selectMenuItem_key");
        },
        methods:{
            handleClick(tab) {
                // if(tab.name == "first") {
                //     this.activeName = 'first';
                //     this.title="评价记录";
                // }else 
                if(tab.name == "second") {
                    this.activeName = 'second';
                    this.title="学生评价统计";
                }else if(tab.name == "three") {
                    this.activeName = 'three';
                    this.title="班级评价统计";
                }else if(tab.name == "eight") {
                    this.activeName = 'eight';
                    this.title="班级评价AI周报";
                }else if(tab.name == "four") {
                    this.activeName = 'four';
                    this.title="我的评价";
                }else if(tab.name == "five") {
                    this.activeName = 'five';
                    this.title="教职评价统计";
                }else if(tab.name == "six") {
                    this.activeName = 'six';
                    this.title="校长报告";
                }else if(tab.name == 'seven'){
                    this.activeName = 'seven'
                    this.title = "巡岗留痕"
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/EvaluateMain.vue